//@ts-ignore
import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { useSession } from "../../hooks/SessionContext";
import Agenda from "../../pages/Agenda/Agenda";
import DarTurno from "../../pages/DarTurno/DarTurno";
import HistoriaClinica from "../../pages/HistoriaClinica/HistoriaClinica";
import "./ExploreContainer.css";

interface ContainerProps {}
//@ts-ignore
const ExploreContainer: React.FC<ContainerProps> = () => {
  const { name } = useParams<{ name: string }>();
  const { hcUL, cargandoSession, setSesionInvalida } = useSession();

  const history = useHistory();

  useEffect(() => {
    if (cargandoSession === false) {
      if ((hcUL === null || hcUL.codigo === 0) && name !== "Privacidad") {
        setSesionInvalida(true);
        // history.push("/ErrorPage", { motivo: 401, path: "explore container" });
      }
    }
  }, [cargandoSession]);

  const renderSwitch = () => {
    switch (name) {
      case "Agenda":
        return <Agenda />;
      case "Paciente":
        return <HistoriaClinica />;
      case "Nuevo Turno":
        return <DarTurno />;
      case "DarTurno":
        return <DarTurno />;
      // case "Privacidad":
      //   return <Privacidad />;
      default:
        history.push("/ErrorPage", { motivo: 404, path: "explore container" });
    }
  };

  return <>{renderSwitch()}</>;
};

export default ExploreContainer;
